import { Injectable } from '@angular/core';
import {
    CanActivate,
    CanActivateChild,
    Router,
    UrlTree
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LicenseService } from '../components/security/services/license.service';

@Injectable({
    providedIn: 'root'
})
export class LicenseGuard implements CanActivate, CanActivateChild {
    constructor(private licenseService: LicenseService, private router: Router) {}

    canActivate(): Observable<boolean | UrlTree> {
        return this.checkLicense();
    }

    canActivateChild(): Observable<boolean | UrlTree> {
        return this.checkLicense();
    }

    // private checkLicense(): Observable<boolean | UrlTree> {
    //     return this.licenseService.getLicenseStatus().pipe(
    //         map(status => {
    //             console.log('dedans')
    //             if (status.status === 'valid' || status.status === 'expiring') {
    //                 return true;
    //             }
    //             console.log('out')
    //             localStorage.clear();
    //             return this.router.createUrlTree(['/error-page/license-expired']);
    //         }),
    //         catchError(() => {
    //             console.log('catching')
    //             localStorage.clear();
    //             return of(this.router.createUrlTree(['/error-page/license-expired']));
    //         })
    //     );
    // }

    private checkLicense(): Observable<boolean | UrlTree> {
        return this.licenseService.getLicenseStatus().pipe(
            map(status => {
                // ⬇️ MISE À JOUR ICI
                this.licenseService.updateStatus(status);

                if (status.status === 'valid' || status.status === 'expiring' || status.status === 'disabled') {
                    console.log('dedans');
                    return true;
                }

                console.log('out');
                localStorage.clear();
                return this.router.createUrlTree(['/error-page/license-expired']);
            }),
            catchError(() => {
                console.log('catching');

                this.licenseService.updateStatus({
                    status: 'missing',
                    message: 'Erreur lors de la vérification de la licence.'
                });

                localStorage.clear();
                return of(this.router.createUrlTree(['/error-page/license-expired']));
            })
        );
    }

}
